import { render } from "./MarketIntelligence.vue?vue&type=template&id=0a745a99&scoped=true"
import script from "./MarketIntelligence.vue?vue&type=script&lang=js"
export * from "./MarketIntelligence.vue?vue&type=script&lang=js"

import "./MarketIntelligence.vue?vue&type=style&index=0&id=0a745a99&lang=css"
import "./MarketIntelligence.vue?vue&type=style&index=1&id=0a745a99&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a745a99"]])

export default __exports__